import React from 'react';
import { LandingTemplate } from '@/components/landing/landingTemplate';
import { GenerateLandingLinkService } from '@/services';
import { landingFlux2AiImageGeneratorConfig } from '@/data/landingConfig/landingFlux2AiImageGeneratorConfig';
import { AggregateSchema } from '../AggregateSchema';
import { schemaObject_Flux2AiImageGenerator } from './schemaObject';

interface Props {}
const Flux2AiImageGenerator: React.FC<Props> = () => {
	return (
		<>
			<AggregateSchema schema={schemaObject_Flux2AiImageGenerator} />
			<LandingTemplate
				data={landingFlux2AiImageGeneratorConfig}
				funnelLinkService={GenerateLandingLinkService.funnelImageGeneratorV2()}
			/>
		</>
	);
};

export default Flux2AiImageGenerator;
